import { Amplify } from "aws-amplify";

export const configureAmplify = () => {
  const environment = process.env.REACT_APP_ENV || "DEV";
  const userPoolId = process.env[`REACT_APP_USER_POOL_ID_${environment}`] || "";
  const userPoolClientId = process.env[`REACT_APP_USER_POOL_CLIENT_ID_${environment}`] || "";
  const identityPoolId = process.env[`REACT_APP_IDENTITY_POOL_ID_${environment}`] || "";


  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId,
        userPoolClientId,
        identityPoolId,
        loginWith: {
          email: true,
        },
        signUpVerificationMethod: "code",
        userAttributes: {
          email: {
            required: true,
          },
        },
        allowGuestAccess: true,
        passwordFormat: {
          minLength: 8,
          requireLowercase: true,
          requireUppercase: true,
          requireNumbers: true,
          requireSpecialCharacters: true,
        },
      },
    },
  });
};
